import React, { useState } from 'react';
import Slider from 'react-slick';
import styles from './styles.module.scss';

import ImagePlaceholder from '../../Placeholder';
import { ReactComponent as Close } from '../../../assets/icons/icon-close.svg';
import { ReactComponent as ArrowPrev } from '../../../assets/icons/icon-arrow-left.svg';
import { ReactComponent as ArrowNext } from '../../../assets/icons/icon-arrow-right.svg';
import placeholder from '../../../assets/placeholder/560.jpg';

import Config from '../../../config/config';

const ProductZoom = ({ images, name, zoom, setZoom, zoomKey }) => {
  const image = images.find((img) => img?.id === zoomKey);
  return (
    <div className={`${styles.zoom} ${zoom ? styles.zoomActive : ''}`}>
      <div className={styles.zoomFlex}>
        <div className={styles.zoomContent}>
          <div>
            <p>{name}</p>
            <button type="button" onClick={() => setZoom(false)}>
              <Close />
            </button>
          </div>
          <div>
            <picture>
              <img src={Config.cdn.cdn_path + image?.url} alt={name} />
            </picture>
          </div>
        </div>
      </div>
    </div>
  );
};

const ProductThumbnails = ({ thumbs, name }) => (
  <div className={styles.thumbnails}>
    <button type="button">
      <img src={Config.cdn.cdn_path + thumbs} alt={name} />
    </button>
  </div>
);

const Prev = ({ onClick }) => (
  <button type="button" onClick={onClick} className={styles.arrowPrev}>
    <ArrowPrev />
  </button>
);
const Next = ({ onClick }) => (
  <button type="button" onClick={onClick} className={styles.arrowNext}>
    <ArrowNext />
  </button>
);

const Slide = ({ item, cmsData, handleZoom }) => (
  <div className={styles.image}>
    {cmsData.Name && item.url ? (
      <button type="button" onClick={() => handleZoom(item?.id)}>
        <picture>
          <img src={Config.cdn.cdn_path + item?.url} alt={cmsData?.Name} />
        </picture>
      </button>
    ) : (
      <ImagePlaceholder mobile={placeholder} />
    )}
  </div>
);

const ProductImage = ({ cmsData }) => {
  const [zoom, setZoom] = useState(false);
  const [zoomKey, setZoomKey] = useState(undefined);
  const isDesktop = window.innerWidth > 1025;
  const moreThan1 = cmsData?.imagesProduct.length > 1;
  const handleZoom = (key) => {
    setZoom(true);
    setZoomKey(key);
  };
  const settings = {
    autoplay: false,
    infinite: true,
    dots: true,
    arrows: isDesktop && moreThan1,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <Prev />,
    nextArrow: <Next />,
    dotsClass: 'product-dots',
    customPaging: (i) => (
      <button type="button" className={styles.customDots}>
        {isDesktop ? (
          <img
            src={
              Config.cdn.cdn_path +
              cmsData?.imagesProduct[i]?.formats?.thumbnail?.url
            }
            alt={cmsData?.Name}
          />
        ) : (
          <span className={styles.mobileDot} />
        )}
      </button>
    ),
  };
  return (
    <div className={styles.container}>
      <Slider {...settings}>
        {cmsData?.imagesProduct.map((item, key) => (
          <Slide
            key={key}
            cmsData={cmsData}
            item={item}
            zoom={zoom}
            handleZoom={handleZoom}
            setZoomKey={setZoomKey}
          />
        ))}
      </Slider>
      {zoom ? (
        <ProductZoom
          images={cmsData?.imagesProduct}
          name={cmsData?.Name}
          zoom={zoom}
          setZoom={setZoom}
          zoomKey={zoomKey}
        />
      ) : (
        ''
      )}
      {!moreThan1 && (
        <ProductThumbnails
          thumbs={cmsData?.imagesProduct[0]?.formats?.thumbnail?.url}
          name={cmsData?.Name}
        />
      )}
    </div>
  );
};

export default ProductImage;
